/**
 * vie-scolaire.js
 * ---------------
 * Incidents de vie scolaire (modele Sanction).
 *
 * Extrait de `directeurApi.js` (559 lignes, toutes les fonctions ajoutees a la
 * suite). Chaque lot ajoutait ses appels en fin de fichier : deux lots ouverts
 * en meme temps entraient donc systematiquement en conflit sur ce fichier.
 * `directeurApi.js` reste le point d'entree — il re-exporte ces modules — pour
 * qu'aucun ecran n'ait a changer ses imports.
 */
import axiosClient from "../axiosClient";

/* ──────────────────────────────────────────────────────────────
   Écritures utilisées par les pages du cockpit (hors /directeur/*)
────────────────────────────────────────────────────────────── */

/**
 * POST /sanctions/ — enregistre un incident (modèle Sanction).
 * Utilisé par la page « Absences & incidents » (bouton du design
 * « Signaler un incident »). Le scope établissement est appliqué par le
 * ViewSet ; le directeur ne peut viser que ses propres élèves.
 * @param {{eleve: number, type: string, date?: string, matiere?: string, raison: string}} payload
 */
export async function creerIncident(payload) {
  const { data } = await axiosClient.post("/sanctions/", payload);
  return data;
}

/** PATCH /sanctions/<id>/ — clôture (resolved) ou réouverture d'un incident. */
export async function setIncidentResolved(id, resolved) {
  const { data } = await axiosClient.patch(`/sanctions/${id}/`, { resolved });
  return data;
}
